
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/terms-conditions",
      function () {
        return require("private-next-pages/docs/terms-conditions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/terms-conditions"])
      });
    }
  